export default __webpack_public_path__ + "files/United States Department of Agriculture-1381b61a52a2b01463156d7c123989f0.png";